import React from 'react';
import {Link} from 'react-router-dom';
import {
    ListItem,
    ListItemText
} from 'material-ui';

const MenuItem = ({
    buttonAction,
    text,
    children,
    onClick,
    activeItem
}) =>
    <ListItem
        button 
        onClick={onClick}
        style={{padding: '10px'}}
        component={Link}
        to={buttonAction}
        className={activeItem ? "menuIcons active activeBorder" : "menuIcons"}
        
    >
        {children}
        <ListItemText
            primary={text}
            className={activeItem ? "menuIcons active" : "menuIcons"}
        />
    </ListItem>;

export default MenuItem;


// WEBPACK FOOTER //
// ./src/containers/layout/menu_item.js